import { BrokerageStatusEnum } from './brokerage-status.enum';
import { ISession } from './session.interface';

export const NEEDS_REVIEW_MESSAGE =
  "Your account is under review. You'll be able to send commissions to your agents once the review is complete.";

export const NEEDS_REVIEW_MESSAGE_KEY =
  'deals.component.upload_commission_disabled_needs_review';

export const NEEDS_REVIEW_REFUSAL_CODE = 'BROKERAGE_NEEDS_REVIEW';

export function isBrokerageInReview(session?: ISession | null): boolean {
  return session?.brokerageStatus === BrokerageStatusEnum.NeedsReview;
}
